if (typeof window !== 'undefined' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        console.log('✅ Service Worker registrado:', registration);
      })
      .catch((error) => {
        console.error('❌ Error al registrar el Service Worker:', error);
      });
  });
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app/index';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

